// extracted by mini-css-extract-plugin
export default {"workflowDetailsDropdownMenu":"workflow-details-dropdown-menu__workflow-details-dropdown-menu__tpOtY"};